import { createStore } from 'vuex'

export default createStore({
  strict:true,
  state: {
    textbook_id: undefined,
    s_subject_id: undefined,
    subject_id: undefined,
    subjects: undefined,
    s_grade_id: undefined,
    grade_id: undefined,
    grades: undefined,
    s_company_id: undefined,
    company_id: undefined,
    companies: undefined,
    text_thumb_image_id: undefined,
    text_thumb_image_path: undefined,
  },
  getters: {
    textbookId:(state = this.state) => {
      return state.textbook_id
    },
    subjectId:(state = this.state) => {
      return state.subject_id
    },
    gradeId:(state = this.state) => {
      return state.grade_id
    },
    companyId: (state = this.state) =>{
      return state.company_id
    },
    textThumbImageId: (state = this.state) =>{
      return state.text_thumb_image_id
    },
    textThumbImagePath: (state = this.state) =>{
      return state.text_thumb_image_path
    },
  },
  mutations: {
    resetIds(){
      this.state.subject_id = undefined
      this.state.grade_id = undefined
      this.state.company_id = undefined
      this.state.image_id = undefined
    },
    resetSearchIds(){
      this.state.s_subject_id = undefined
      this.state.s_grade_id = undefined
      this.state.s_company_id = undefined
    },
    setTextbookId(state, textbook_id){
      state.textbook_id = textbook_id
    },
    setSubjects(subjects){
      this.state.subjects = subjects
    },
    setSubjectId(state, subject_id){
      state.subject_id = subject_id
    },
    setGrades(grades) {
      this.state.grades = grades
    },
    setGradeId(state, grade_id){
      state.grade_id = grade_id
    },
    setCompanies(companies){
      this.state.companies = companies
    },
    setCompanyId(state, company_id){
      state.company_id = company_id
    },
    setTextThumbImageId(state, image_id){
      state.text_thumb_image_id = image_id
    },
    setTextThumbImagePath(state, image_path){
      state.text_thumb_image_path = image_path
    },
  },
  actions: {
  },
  modules: {
  }
})
